import { createRouter, createWebHistory } from 'vue-router'

import CustomerDisplay from '@/components/CustomerDisplay.vue'
import LocationSelector from '@/components/LocationSelector.vue'
import Login from '@/components/Login.vue'
import SupportLogin from '@/components/SupportLogin.vue'
import { useAuthStore } from '@/store/auth'

const routes = [
  {
    path: '/',
    redirect: { name: 'customerDisplay' }
  },
  {
    name: 'customerDisplay',
    path: '/display',
    component: CustomerDisplay
  },
  {
    name: 'locationSelector',
    path: '/select',
    component: LocationSelector
  },
  {
    name: 'login',
    path: '/login',
    component: Login
  },
  {
    name: 'supportLogin',
    path: '/support-login',
    component: SupportLogin
  },
  { path: '/:catchAll(.*)', redirect: '/select' }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, _from, next) => {
  const needsAuth = !['login', 'supportLogin'].includes(to.name as string)
  const authStore = useAuthStore()
  const isAuthenticated = authStore.isAuthenticated

  if (needsAuth && !isAuthenticated) {
    next({
      name: 'login'
    })
  } else {
    next()
  }
})

export default router
